import './IndicatorManager.scss';

import { WarningAmber } from "@mui/icons-material";
import { Info } from "@mui/icons-material";
import { Done } from "@mui/icons-material";
import { Error } from "@mui/icons-material";

export const IndicatorManager = ({isRequired, isEmpty, error}) => {

    const getIndicatorClass = () => {

        if (error) {
            return "--failure"
        }
        if (!isEmpty) {
            return "--success"
        }
        if (isRequired) {
            return "--warning"
        }

        return "--default"
    }

    const checkField = () => {

        if (error) {
            return <Error style={{fontSize: "22px", border: "none", background: "none"}}/>
        }
        if (!isEmpty) {
            return <Done style={{fontSize: "22px", border: "none", background: "none"}}/>
        }
        if (isRequired) {
            return <WarningAmber style={{fontSize: "22px", border: "none", background: "none"}}/>
        }

        return <Info className={"default"} style={{fontSize: "22px", border: "none", background: "none"}}/>
    }

    return (
        <div className={`indicator-manager ${getIndicatorClass()}`}>
            {checkField()}
        </div>
    )
}